import * as React from 'react';
import Utils from '../../../../../utils';

import { StyledRevealButton } from './styles';
interface RevealButtonProps {
	onClick?: (e: React.FormEvent<HTMLInputElement>) => void;
}

const RevealButton = ({ onClick }: RevealButtonProps) => (
	<StyledRevealButton onClick={onClick}>
		{Utils.getSvgIcon('iconset_eye')}
	</StyledRevealButton>
);

export default RevealButton;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MultiAppAuthentication/Form/Input/ButtonReveal/index.tsx